/* eslint-disable sort-keys */
export const urls: Record<
  'gb',
  Record<string, '/l/uk/en' | `/l/uk/en/${string}`>
> = {
  gb: {
    // Home
    '': '/l/uk/en/home',

    // Alumni
    alumni: '/l/uk/en/alumni',

    // B2B
    enterprise: '/l/uk/en/b2b',
    'enterprise/contact': '/l/uk/en/b2b/apply',

    // Blog
    blog: '/l/uk/en/blog',

    // Campus
    london: '/l/uk/en/campus/lon',
    remote: '/l/uk/en/campus/rmt',

    // Career
    career: '/l/uk/en/career',

    // Courses
    'web-development': '/l/uk/en/course/wd',
    'data-analytics': '/l/uk/en/course/da',
    'ux-ui-design': '/l/uk/en/course/ux',
    cybersecurity: '/l/uk/en/course/cy',

    // FAQ
    faq: '/l/uk/en/faq',

    // Financing Options
    'financing-options': '/l/uk/en/financing',

    // Forms
    apply: '/l/uk/en/apply',
    apply2: '/l/uk/en/full-apply',
    contact: '/l/uk/en/contact',
    'financing-form': '/l/uk/en/financing-form',
    'thank-you': '/l/uk/en/thank-you',

    // Syllabus Forms
    'ai-consulting-integration/syllabus': '/l/uk/en/syllabus/ac',
    'artificial-intelligence/syllabus': '/l/uk/en/syllabus/ai',
    'cloud-engineer/syllabus': '/l/uk/en/syllabus/ce',
    'cybersecurity/syllabus': '/l/uk/en/syllabus/cy',
    'data-analytics/syllabus': '/l/uk/en/syllabus/da',
    'data-engineering/syllabus': '/l/uk/en/syllabus/de',
    'devops-cloud-computing/syllabus': '/l/uk/en/syllabus/dv',
    'digital-marketing/syllabus': '/l/uk/en/syllabus/mk',
    'data-science-machine-learning/syllabus': '/l/uk/en/syllabus/ml',
    'ai-product-manager/syllabus': '/l/uk/en/syllabus/pm',
    'ux-ui-design/syllabus': '/l/uk/en/syllabus/ux',
    'web-development/syllabus': '/l/uk/en/syllabus/wd',

    // PDP
    'ai-consulting-integration/remote': '/l/uk/en/pdp/ac/rmt',
    'artificial-intelligence/remote': '/l/uk/en/pdp/ai/rmt',
    'cloud-engineer/remote': '/l/uk/en/pdp/ce/rmt',
    'data-engineering/remote': '/l/uk/en/pdp/de/rmt',
    'devops-cloud-computing/remote': '/l/uk/en/pdp/dv/rmt',
    'digital-marketing/remote': '/l/uk/en/pdp/mk/rmt',
    'data-science-machine-learning/remote': '/l/uk/en/pdp/ml/rmt',
    'ai-product-manager/remote': '/l/uk/en/pdp/pm/rmt',
  },
};
/* eslint-enable sort-keys */
